import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ResultCTACompare() {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1rem',
      marginTop: '1.5rem',
      marginBottom: '1rem',
      fontFamily: 'Inter, sans-serif'
    }}>
      <button 
        onClick={() => navigate('/chemistry-test/info')}
        style={{
          background: 'linear-gradient(90deg, #ec4899, #8b5cf6, #3b82f6)',
          backgroundSize: '200% auto',
          color: 'white',
          border: 'none',
          padding: '1.25rem 2rem',
          borderRadius: '999px',
          fontSize: '1.15rem',
          fontWeight: '800',
          cursor: 'pointer',
          width: '100%',
          maxWidth: '400px',
          boxShadow: '0 10px 30px rgba(139, 92, 246, 0.4)',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-3px)';
          e.currentTarget.style.boxShadow = '0 15px 35px rgba(236, 72, 153, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 10px 30px rgba(139, 92, 246, 0.4)';
        }}
      >
        Compare with Another Face
      </button>
      <div style={{ textAlign: 'center' }}>
        <p style={{ margin: 0, fontSize: '0.85rem', color: '#94a3b8', fontWeight: '500' }}>
          Upload another face to explore your first-impression chemistry.
        </p>
      </div>
    </div>
  );
}
